import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Column, TotalItem, Summary, HeaderFilter, FilterRow, FilterPanel } from "devextreme-react/data-grid";
import DateBox from 'devextreme-react/date-box';
import { PaginaListado } from "../../../Componentes/Compuestos/Paginas/PaginaListado";
import { LVGridCabeceraReporte } from "../../../Componentes/Basicos/LVGridCabeceraReporte";

export const CON_Reporte_GeneralProductivo = () => {
  const [data, setData] = useState([])
  const { CONT_Reportes: { function_CONT_Reportes_GeneralProductivo } } = require('neftis7_apicaller');

  const handleDataLoaded = (data) => {
    setData(data);
  };

  return (
    <PaginaListado
      Titulo="GENERAL PRODUCTIVO"
      funcion={function_CONT_Reportes_GeneralProductivo}
      onDataLoaded={handleDataLoaded}
    >
      <div className="table-responsive">
        {data.length > 0 ? (
          <LVGridCabeceraReporte
            dataSource={data}
            id="gridContainer"
          >
            <HeaderFilter visible={false} />
            <FilterPanel visible={false} />
            <FilterRow visible={false} />
            <Summary>
              <TotalItem
                column="Id"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`} />



              <Column caption="Cant.Clientes" dataField="" width="150" alignment="Right" dataType="number" allowSorting={true} />
              <Column caption="Cant.Items" dataField="" width="150" alignment="Right" dataType="number" allowSorting={true} />
              <Column caption="Items Facturados" dataField="CantidadFacturada" width="150" alignment="Right" dataType="number" allowSorting={true} />
              <Column caption="Items N.C." dataField="" width="150" alignment="Right" dataType="number" allowSorting={true} />

              <TotalItem
                column="CantidadNOFacturada"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value}`} />

              <TotalItem
                column="CantidadRemitida"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value}`} />

              <TotalItem
                column="CantidadPedidos"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value}`} />

              <TotalItem
                column="ClientesInvolucrados"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value}`} />

              <TotalItem
                column="CantidadItems"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value}`} />

              <TotalItem
                column="CantidadFacturadaNC"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value}`} />

              <TotalItem
                column="ImporteNOFacturado"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />

              <TotalItem
                column="ImporteFacturacion"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />

              <TotalItem
                column="ImporteCobranzas"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />

              <TotalItem
                column="ImporteTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />

            </Summary>

            <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} allowSorting={false} />

            <Column caption="Pedidos NO Facturados" alignment="Center" >
              <Column caption="Cant.Items" dataField="CantidadNOFacturada" width="150" alignment="Right" dataType="number" allowSorting={true} />
              <Column caption="Importe" dataField="ImporteNOFacturado" width="150" alignment="Right" dataType="number" format="currency" allowSorting={true} />
            </Column>

            <Column caption="Facturación" dataField="ImporteFacturacion" width="150" alignment="Right" dataType="number" format="currency" allowSorting={true} />
            <Column caption="Cant.Remitida" dataField="CantidadRemitida" width="150" alignment="Right" dataType="number" allowSorting={true} />
            <Column caption="Cobranzas" dataField="ImporteCobranzas" width="150" alignment="Right" dataType="number" format="currency" allowSorting={true} />

            <Column caption="Pedidos Total" alignment="Center" >
              <Column caption="Cant.Pedidos" dataField="CantidadPedidos" width="150" alignment="Right" dataType="number" allowSorting={true} />
              <Column caption="Cant.Clientes" dataField="ClientesInvolucrados" width="150" alignment="Right" dataType="number" allowSorting={true} />
              <Column caption="Cant.Items" dataField="CantidadItems" width="150" alignment="Right" dataType="number" allowSorting={true} />
              <Column caption="Importe Pedidos" dataField="ImporteTotal" width="150" alignment="Right" dataType="number" format="currency" allowSorting={true} />
              <Column caption="Items Facturados" dataField="CantidadFacturada" width="150" alignment="Right" dataType="number" allowSorting={true} />
              <Column caption="Items N.C." dataField="CantidadFacturadaNC" width="150" alignment="Right" dataType="number" allowSorting={true} />
            </Column>

          </LVGridCabeceraReporte>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListado>
  );
};
